import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import backButton from "./Images/back.png";

const Bearing = () => {
  const userEmail = sessionStorage.getItem("userEmail");
  const navigate = useNavigate();

  const [folderName, setFolderName] = useState("default");
  const [bearingUrl, setBearingUrl] = useState("");
  const [glbUrl, setGlbUrl] = useState("");
  const [inputs, setInputs] = useState({
    outer_diameter: "",
    inner_diameter: "",
    width: "",
    ball_diameter: "",
    number_of_balls: "",
  });

  // Redirect if not logged in
  useEffect(() => {
    if (!userEmail) navigate("/signin");
  }, [userEmail, navigate]);

  // Inject <model-viewer> once
  useEffect(() => {
    if (!document.querySelector("script#model-viewer")) {
      const script = document.createElement("script");
      script.id = "model-viewer";
      script.type = "module";
      script.src =
        "https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js";
      document.head.appendChild(script);
    }
  }, []);

  // Fetch folder name
  useEffect(() => {
    const fetchFolderName = async () => {
      try {
        const response = await fetch("https://www.d-rosa.ai/appname");
        const data = await response.json();
        setFolderName(data.foldername || "default");
      } catch (error) {
        console.error("Error fetching folder name:", error);
      }
    };
    fetchFolderName();
  }, []);

  const handleChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  // Generate STEP file
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        "https://www.d-rosa.ai/bearingdesign",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            file_path: `/var/www/myflaskapp/flask_static/${userEmail}/${folderName}`,
            user_email: userEmail,
            folder_path: folderName,
            outer_diameter: parseInt(inputs.outer_diameter),
            inner_diameter: parseFloat(inputs.inner_diameter),
            width: parseFloat(inputs.width),
            ball_diameter: parseFloat(inputs.ball_diameter),
            number_of_balls: parseInt(inputs.number_of_balls),
          }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        setBearingUrl(data.bearingurl || "");
        alert("Bearing design is completed!!");
      } else {
        console.error("Error sending bearing data");
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
    }
  };

  // Convert STEP ? GLB and display
  const handleView = async () => {
    try {
      const response = await fetch(
        "https://www.d-rosa.ai/BearingSteptoGlbb",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            file_path: `/var/www/myflaskapp/flask_static/${userEmail}/${folderName}`,
            user_email: userEmail,
            folder_path: folderName,
          }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        setGlbUrl(data.glburl || "");
      } else {
        console.error("Error converting to GLB");
      }
    } catch (error) {
      console.error("Error in handleView:", error);
    }
  };

  return (
    <div id="image-container">
      <center>
        <h2 className="center-heading">Bearing Design</h2>
      </center>
      <p>Signed in as: {userEmail}</p>

      <form onSubmit={handleSubmit}>
        <input
          type="number"
          name="outer_diameter"
          value={inputs.outer_diameter}
          onChange={handleChange}
          placeholder="Outer Diameter"
          className="w-full p-2 border rounded"
          required
        />
        <br /><br />

        <input
          type="number"
          name="inner_diameter"
          value={inputs.inner_diameter}
          onChange={handleChange}
          placeholder="Inner Diameter"
          className="w-full p-2 border rounded"
          required
        />
        <br /><br />

        <input
          type="number"
          name="width"
          value={inputs.width}
          onChange={handleChange}
          placeholder="Width"
          className="w-full p-2 border rounded"
          required
        />
        <br /><br />

        <input
          type="number"
          name="ball_diameter"
          value={inputs.ball_diameter}
          onChange={handleChange}
          placeholder="Ball Diameter"
          className="w-full p-2 border rounded"
          required
        />
        <br /><br />

        <input
          type="number"
          name="number_of_balls"
          value={inputs.number_of_balls}
          onChange={handleChange}
          placeholder="Number of Balls"
          className="w-full p-2 border rounded"
          required
        />
        <br /><br />

        <button type="submit">Submit</button>
      </form>

      <br />
      <p>Bearing File Path: {bearingUrl}</p>
      <br />

      {bearingUrl && (
        <>
          <button
            onClick={handleView}
            style={{ padding: "10px 20px", fontSize: "16px" }}
          >
            View
          </button>
          <br /><br />
          <a href={bearingUrl} target="_blank" rel="noopener noreferrer">
            <button style={{ padding: "10px 20px", fontSize: "16px" }}>
              Download
            </button>
          </a>
        </>
      )}

      {glbUrl && (
        <div style={{ marginTop: "20px" }}>
          <h3>3D Bearing Model</h3>
          <model-viewer
            src={glbUrl}
            alt="Bearing model"
            auto-rotate
            camera-controls
            ar
            shadow-intensity="1"
            style={{ width: "600px", height: "400px", backgroundColor: "green" }}
          ></model-viewer>
        </div>
      )}

      <br />
      <button onClick={() => navigate("/previous-page")}>
        <img src={backButton} alt="Back" width="60" height="60" />
      </button>

      <footer className="footer-section">
        <div className="text-6">
          &copy; 2022 HYDAX Hydraulics Pvt. Ltd. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default Bearing;
